import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { ROUTES } from '../../../../routes';
import Card from '../../../common/Card/Card';
import Slider from "react-slick";
import styles from "./Settings.module.scss";

const Settings = () => {
    const settings = {
        dots: false,
        infinite: false,
        arrow: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                arrow: true,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 435,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <>
            {/* <Card
                title="Settings"
                bodyClassName={styles.body}
                className={styles.settings}
            >
            </Card> */}
            <section className={styles.settings}>
                <div className='settings_innertab'>
                    <div className='navTabs'>
                        <Slider {...settings}>
                            <NavLink className="nav-link" to={ROUTES.MY_PROFILE}>My Profile</NavLink>
                            <NavLink className="nav-link" to={ROUTES.FEES}>Fees</NavLink>
                            <NavLink className="nav-link" to={ROUTES.TERMS_CONDITIONS}>Terms & Conditions</NavLink>
                            <NavLink className="nav-link" to={ROUTES.PRIVACY_POLICY}>Privacy Policy</NavLink>
                        </Slider>
                    </div>
                </div>
                <div className={styles.tabs}>
                </div>
                <div className={styles.settings_content}>
                    <Outlet />
                </div>
            </section>
        </>
    )
}

export default Settings
